import debug from 'debug'
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ROUTE_SUGGEST } from '../../routes'
import { selectHasUserConsentedForPushNotifications } from '../../store/cmp/cmp.selectors'
import { selectCurrentHistoryRoute } from '../../store/history/history.selectors'
import { selectShouldDisplayPush } from '../../store/incentive/incentive.selectors'
import { setPushAcceptation, setPushDisplayed } from '../../store/incentive/incentiveSlice'
import { selectHeaderHeight } from '../../store/ui/ui.selectors'
import { isGE } from '../Device'
import { withEmptyFallbackErrorBoundary } from '../error/EmptyFallbackErrorBoundary'
import RectangleActionButton, {
  COLOR_GREY_EMPTY,
  SIZE_MEDIUM
} from '../genericComponents/buttons/RectangleActionButton'
import { withFrenchSite } from '../i18n/i18nSite'
import wait from '../utils/wait'
import s from './PushNotificationPopup.less'
import { askForPush, loadPushLibrary } from './PushNotificationService'

const d = debug('push')

const appearDelay = 2000

const PushNotificationPopup = () => {
  const dispatch = useDispatch()
  const [displayed, setDisplayed] = useState(false)

  const shouldDisplayPush = useSelector(selectShouldDisplayPush)
  const hasUserConsentedForPushNotifications = useSelector(selectHasUserConsentedForPushNotifications)
  const currentRoute = useSelector(selectCurrentHistoryRoute)
  const headerHeight = useSelector(selectHeaderHeight)

  useEffect(() => {
    if (hasUserConsentedForPushNotifications && shouldDisplayPush) {
      wait(appearDelay)
        .then(loadPushLibrary)
        .then(() => {
          setDisplayed(true)
          dispatch(setPushDisplayed())
        })
    }
  }, [hasUserConsentedForPushNotifications, shouldDisplayPush])

  useEffect(() => {
    if (displayed && !isGE() && currentRoute === ROUTE_SUGGEST) setDisplayed(false)
  }, [displayed, currentRoute])

  const registerAndClose = useCallback(() => {
    askForPush().then(() => dispatch(setPushAcceptation()))
    setDisplayed(false)
  }, [setDisplayed])

  const close = useCallback(() => {
    d('Push > refused from popup')
    setDisplayed(false)
  }, [setDisplayed])

  if (!displayed) return <></>

  return (
    <div
      className={s.container}
      style={{
        top: !isGE() ? headerHeight : null
      }}
    >
      <p>Souhaitez-vous activer les notifications pour être informé(e) des nouveautés sur Mappy ? 🔔</p>
      <div className={s.buttons}>
        <RectangleActionButton label="Oui j’accepte !" onClick={registerAndClose} size={SIZE_MEDIUM} />
        <RectangleActionButton color={COLOR_GREY_EMPTY} label="Non" onClick={close} size={SIZE_MEDIUM} />
      </div>
    </div>
  )
}

// webpack:BrowserOnly
export default withFrenchSite(withEmptyFallbackErrorBoundary(PushNotificationPopup))
